(function () {
  'use strict';

  if (window.__bratsLiveHero) {
    window.__bratsLiveHero.scan();
    return;
  }

  var mounted = new Map();
  var selector = '.brats-live-hero';

  function timestamp(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|([+-])(\d{2}):(\d{2}))$/.exec(value || '');
    if (!match) return null;
    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var hour = Number(match[4]);
    var minute = Number(match[5]);
    var second = Number(match[6]);
    var offsetHours = Number(match[9] || 0);
    var offsetMinutes = Number(match[10] || 0);
    if (year < 100 || hour > 23 || minute > 59 || second > 59 || offsetHours > 23 || offsetMinutes > 59) return null;
    var civil = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    if (civil.getUTCFullYear() !== year || civil.getUTCMonth() !== month - 1 || civil.getUTCDate() !== day) return null;
    var parsed = Date.parse(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function eventTime(start, zone) {
    try {
      var date = new Date(start);
      var day = new Intl.DateTimeFormat('en-AU', {
        timeZone: zone, weekday: 'long', day: 'numeric', month: 'long'
      }).format(date);
      var clock = new Intl.DateTimeFormat('en-AU', {
        timeZone: zone, hour: 'numeric', minute: '2-digit', hour12: true, timeZoneName: 'short'
      }).format(date);
      var place = zone.split('/').pop().replace(/_/g, ' ');
      return day + ' at ' + clock + ' (' + place + ')';
    } catch (_) {
      return eventTime(start, 'Australia/Melbourne');
    }
  }

  function mount(section) {
    if (mounted.has(section)) return;
    var state = section.querySelector('[data-brats-countdown-state]');
    var clock = section.querySelector('[data-brats-countdown]');
    var time = section.querySelector('[data-brats-event-time]');
    var link = section.querySelector('[data-brats-room-link]');
    if (!state || !clock || !time || !link) return;

    var start = timestamp(section.dataset.eventStart);
    var status = section.dataset.eventStatus;
    function say(element, value) {
      if (element.textContent !== value) element.textContent = value;
    }
    if (start !== null) {
      time.textContent = eventTime(start, section.dataset.eventTimezone || 'Australia/Melbourne');
      time.setAttribute('data-event-valid', 'true');
    } else {
      time.textContent = status === 'live' ? 'Show time not listed' : status === 'ended' ? 'Show date not listed' : 'Date coming soon';
    }

    var interval = null;
    function render() {
      var destination = new URL(link.getAttribute('href'), window.location.href);
      if (status !== 'live' && status !== 'ended' && (start === null || start > Date.now())) destination.hash = 'get-ready-to-bid';
      else if (destination.hash === '#get-ready-to-bid') destination.hash = '';
      link.href = destination.href;
      if (!clock.hidden) clock.hidden = true;
      if (status === 'ended') {
        say(state, 'This show has ended');
        say(link, 'See the live room');
      } else if (status === 'live') {
        say(state, 'Annie is live now');
        say(link, 'Watch and bid');
      } else if (start === null) {
        say(state, 'Date coming soon');
        say(link, 'Sign up to bid');
      } else {
        var remaining = Math.max(0, Math.ceil((start - Date.now()) / 1000));
        if (remaining === 0) {
          say(state, 'Scheduled start has passed — check the live room');
          say(link, 'Check live room');
        } else {
          var days = Math.floor(remaining / 86400);
          var hours = Math.floor((remaining % 86400) / 3600);
          var minutes = Math.floor((remaining % 3600) / 60);
          var seconds = remaining % 60;
          section.querySelector('[data-brats-days]').textContent = String(days);
          section.querySelector('[data-brats-hours]').textContent = String(hours).padStart(2, '0');
          section.querySelector('[data-brats-minutes]').textContent = String(minutes).padStart(2, '0');
          section.querySelector('[data-brats-seconds]').textContent = String(seconds).padStart(2, '0');
          say(state, 'Starts in');
          if (clock.hidden) clock.hidden = false;
          say(link, 'Sign up to bid');
        }
      }
      if (interval && (status === 'live' || status === 'ended' || start === null || start <= Date.now())) {
        clearInterval(interval);
        interval = null;
      }
    }
    render();
    if (status !== 'live' && status !== 'ended' && start !== null && start > Date.now()) {
      interval = setInterval(render, 1000);
    }
    mounted.set(section, function () { if (interval) clearInterval(interval); });
  }

  function scan(root) {
    root = root || document;
    if (root.matches && root.matches(selector)) mount(root);
    root.querySelectorAll(selector).forEach(mount);
  }

  function unload(event) {
    var root = event.target;
    var sections = [];
    if (root.matches && root.matches(selector)) sections.push(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(function (section) { sections.push(section); });
    sections.forEach(function (section) {
      var destroy = mounted.get(section);
      if (destroy) destroy();
      mounted.delete(section);
    });
  }

  function load(event) { scan(event.target); }

  document.addEventListener('shopify:section:load', load);
  document.addEventListener('shopify:section:unload', unload);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }, { once: true });
  scan();

  window.__bratsLiveHero = {
    scan: scan,
    destroyAll: function () {
      mounted.forEach(function (destroy) { destroy(); });
      mounted.clear();
      document.removeEventListener('shopify:section:load', load);
      document.removeEventListener('shopify:section:unload', unload);
    }
  };
})();
